<!-- eslint-disable max-len -->
<template>
	<PageContainer>
		<AmeliproCard :card-title="cardTitle">
			<v-sheet
				class="overflow-y-auto cgu-content"
				max-height="50vh"
			>
				<v-list>
					<v-list-item>
						<v-list-item-content>
							<h3 class="font-weight-bold mb-8 mt-8">
								PREAMBULE
							</h3>
							<p class="mb-2">
								Les présentes Conditions Générales d'Utilisation ont pour objet
								de définir les modalités et conditions dans lesquelles la Caisse
								Nationale de l'Assurance Maladie met le service à disposition de
								l'Utilisateur.
							</p>
							<p class="mb-2">
								En acceptant sans réserve les présentes Conditions Générales
								d'Utilisation, l'Utilisateur confirme son accord des Conditions
								Générales d'Utilisation suivantes sur la plateforme et consent
								au traitement de ses données à caractère personnel tel que
								décrit ci-après.
							</p>
							<p class="mb-2">
								La Plateforme, ses Contenus et Services et les présentes
								Conditions Générales d’Utilisation sont régis par le droit
								français, quel que soit le lieu d’utilisation. En cas de
								contestation éventuelle, et après l’échec de toute tentative de
								recherche d’une solution amiable, les tribunaux administratifs
								français seront seuls compétents pour répondre à ce litige.
							</p>
							<p class="mb-2">
								L’utilisation du présent service nécessite l’expression du
								consentement à la création d’un compte ainsi qu’à l’acceptation
								des présentes Conditions Générales d’Utilisation. Ces
								consentements sont matérialisés par une case dédiée à cocher.
							</p>
							<p class="mb-2">
								L’utilisation de ce service est facultative et gratuite (hors
								coûts éventuellement liés à votre abonnement auprès d’un
								fournisseur d’accès) et n’a aucun impact sur les conditions de
								remboursement et le niveau de prise en charge de l’Utilisateur
								par l’Assurance Maladie.
							</p>
							<p class="mb-2">
								Ce service s'adresse à tout professionnel de santé ayant
								effectué des gardes ou astreintes.
							</p>
							<p class="mb-2">
								Les données relatives aux gardes et astreintes (nombre, date,
								lieu, données d'identification du professionnel de santé et du
								mandataire) sont transmises au préalable par les Logiciels de
								Gestion de Garde (LGG) du corps de métier du professionnel de
								santé au sein du service PEGASE.
							</p>
							<p class="mb-2">
								La transmission de ces informations est donc un prérequis afin
								que l’Utilisateur puisse bénéficier de l’ensemble des
								fonctionnalités du présent service.
							</p>
							<p class="mb-2">
								Ainsi, au sens des présentes Conditions Générales d'Utilisation,
								sont définis comme suit :
							</p>
							<ul class="mb-2">
								<li>
									<span class="text-decoration-underline">Utilisateur</span> :
									professionnel de santé (médecin ou pharmacien) ou son
									mandataire utilisant le présent service;
								</li>
								<li>
									<span class="text-decoration-underline">Mandataire</span> :
									personne mandatée par le professionnel de santé pour
									l’utilisation du présent service pour son compte conformément
									aux informations présentes dans les plannings transmis via les
									LGG ;
								</li>
								<li>
									<span class="text-decoration-underline">Responsable de planning</span>
									:
									<ul>
										<li>
											Pour les médecins, l'ARS en validant le planning dans le
											LGG–ORDIGARD.
										</li>
										<li>Pour les pharmaciens, les syndicats de pharmaciens.</li>
									</ul>
								</li>
								<li>
									<span class="text-decoration-underline">Caisse d'Assurance Maladie de rattachement (CPAM/CGSS)
										:</span>
									Caisse d'Assurance Maladie à laquelle le professionnel de
									santé a ses droits rattachés.
								</li>
							</ul>

							<h3 class="font-weight-bold mb-8 mt-8">
								1. PRESENTATION DU SERVICE
							</h3>
							<p class="mb-2">
								Le présent service PEGASE est un outil développé par la Caisse
								Nationale de l'Assurance Maladie. Il permet la réception des
								gardes et astreintes effectuées par les professionnels de santé
								et la validation de ces dernières par les personnes concernées
								afin que l'Assurance Maladie puisse procéder à leur paiement.
							</p>
							<p class="mb-2">
								Ainsi, le présent service contient des fonctionnalités
								permettant à l'Utilisateur :
							</p>
							<ul class="mb-2">
								<li>d'être informé des demandes de paiements à valider;</li>
								<li>
									de valider ou invalider les demandes de paiement de gardes et
									astreintes déclarées par le responsable des plannings de
									gardes via la transmission des informations par le LGG;
								</li>
								<li>
									de déclencher le paiement des gardes et astreintes auprès de
									la Caisse d'Assurance Maladie de rattachement du professionnel
									de santé de façon totalement dématérialisée;
								</li>
								<li>
									de consulter la liste des gardes et astreintes que les
									professionnels de santé ont effectuées ainsi qu'un
									récapitulatif de la demande de paiements comportant la date de
									validation.
								</li>
							</ul>

							<h3 class="font-weight-bold mb-8 mt-8">
								2. ACCES AU SERVICE
							</h3>
							<h4 class="font-weight-bold">
								2.1 Modalités d'accès au service
							</h4>
							<p class="mb-2">
								Deux modalités d'accès au téléservice sont possibles :
							</p>
							<ul class="mb-2">
								<li>
									Via Amelipro : Pour les utilisateurs disposant d'un compte
									professionnel sur Amelipro, ces derniers y accèdent après
									s'être authentifiés sur le site Amelipro, en cliquant sur
									l'onglet dédié au téléservice (<a
										href="https://espacepro.ameli.fr"
										target="_blank"
									>https://espacepro.ameli.fr</a>); dans ce cas les Conditions Générales d’Utilisation du site
									Amelipro s’appliquent.
								</li>
								<li>
									Via l'URL suivant «<a
										href="https://pegase.ameli.fr"
										target="_blank"
									>https://pegase.ameli.fr</a>» : Pour les utilisateurs ne disposant pas d'un compte
									Amelipro, via la connexion à un site internet à l'adresse
									précitée et la création d'un compte.
								</li>
							</ul>

							<h4 class="font-weight-bold mt-2">
								2.2 Disponibilité du service
							</h4>
							<p class="mb-2">
								Le présent service est accessible 7 jours sur 7 et 24 heures sur
								24 à l’exception des cas de force majeure, de difficultés
								informatiques, de difficultés liées à la structure du réseau de
								télécommunication ou de difficultés techniques.
							</p>
							<p class="mb-2">
								Pour des raisons de maintenance, l’Assurance Maladie pourra
								interrompre l’accès au service et s’efforcera d’en avertir
								préalablement les utilisateurs. L’indisponibilité du service ne
								donne droit à aucune indemnité.
							</p>
							<p class="mb-2">
								L’Assurance Maladie ne saurait être tenue responsable des
								conséquences liées à une absence de disponibilité du service
								pour l’un des motifs susmentionnés.
							</p>

							<h3 class="font-weight-bold mb-8 mt-8">
								3. GESTION DE PROFIL
							</h3>
							<p class="mb-2">
								En fonction de la modalité d'accès au service choisi par
								l'Utilisateur, la gestion de profil diverge :
							</p>
							<ul class="mb-2">
								<li>
									Accès via Amelipro : Aucune création de compte est nécessaire
									via cet accès, le professionnel de santé devant disposer d’une
									carte CPS délivrée par l’ANS.
								</li>
								<li>
									Accès via l'URL suivant «<a
										href="https://pegase.ameli.fr"
										target="_blank"
									>https://pegase.ameli.fr</a>» : la création d'un compte est nécessaire (point 3.1)
								</li>
							</ul>

							<h4 class="font-weight-bold mt-2">
								3.1 Création d'un compte
							</h4>
							<p class="mb-2">
								Pour ce qui relève de l'accès via l'URL au service,
								l'Utilisateur ou son mandataire ne peuvent créer leur compte
								directement sur le service PEGASE :
							</p>
							<ul class="mb-2">
								<li>
									Pour le mandataire, la Caisse d’Assurance Maladie de
									rattachement du professionnel de santé qui l’a mandaté lui
									crée un compte.
								</li>
								<li>
									Pour les professionnels de santé concernés, qui ne peuvent se
									connecter via Amelipro, ils doivent effectuer une demande de
									création de compte PEGASE en se rapprochant de leur Caisse
									d’Assurance Maladie de rattachement.
								</li>
							</ul>

							<p class="mb-0 mt-2">
								La création d'un compte nécessite :
							</p>
							<ul class="mb-2">
								<li>
									un identifiant : l'identifiant est le numéro d'Assurance
									Maladie (9 caractères), le RPPS, ou le n° SIRET(14 caractères)
									/FINESS (9 caractères) - il s’agit de l’identifiant transmis
									par les LGG ;
								</li>
								<li>
									Et un mot de passe. Le mot de passe est strictement personnel,
									il convient de le garder secret. Par sécurité, l’Utilisateur
									est invité à ne jamais communiquer le mot de passe permettant
									l'accès à son compte personnel.
								</li>
							</ul>
							<p class="mb-2">
								Suite à la création du compte par la Caisse d’Assurance Maladie
								de rattachement, le service envoie un mail à l’Utilisateur
								l’informant qu’un compte lui a été créé et qu’il est invité à y
								accéder par le lien présent dans le corps du mail afin de
								définir son nouveau mot de passe. Dans ce même mail, il est
								indiqué que son identifiant est son « type d’identifiant ». Le
								type d’identifiant peut être le numéro d'Assurance Maladie (9
								caractères), le RPPS (11 caractères), le n° SIRET (14
								caractères) ou le n° FINESS (9 caractères) - il s’agit de
								l’identifiant transmis par les LGG.
							</p>
							<p class="mb-2">
								Après saisie du nouveau mot de passe et suite à la validation
								par l’Utilisateur, il peut alors se connecter en saisissant son
								identifiant, et son nouveau mot de passe.
							</p>

							<h4 class="font-weight-bold mt-2">
								3.2 Gestion du compte
							</h4>
							<h5 class="font-weight-bold">
								3.2.1 Utilisation de l'adresse de courrier électronique
							</h5>
							<p class="mb-2">
								La saisie d'une adresse de courrier électronique valide est
								obligatoire pour la gestion d'une demande de paiement de gardes
								et d’astreintes.
							</p>

							<h5 class="font-weight-bold mt-2">
								3.2.2 Perte de son mot de passe
							</h5>
							<p class="mb-2">
								L’Utilisateur, en cas de perte de son mot de passe, a la
								possibilité de contacter la Caisse d’Assurance Maladie de
								rattachement gestionnaire de son compte ou de solliciter un
								nouveau mot de passe au travers du service PEGASE.
							</p>

							<h5 class="font-weight-bold mt-2">
								3.2.3 Changement de mot de passe
							</h5>
							<p class="mb-2">
								Le changement de mot de passe est possible depuis un formulaire
								du service PEGASE.
							</p>

							<h5 class="font-weight-bold mt-2">
								3.2.4 Consultation des données du compte
							</h5>
							<p class="mb-2">
								L'Utilisateur a la possibilité d'accéder à l'ensemble des
								données issues de son compte et de prendre connaissance des
								informations le concernant.
							</p>

							<h4 class="font-weight-bold mt-2">
								3.3 Suppression du compte
							</h4>
							<p class="mb-2">
								La suppression d’un compte identifiant/mot de passe se fait de
								manière automatique au terme de la durée de conservation fixée à
								l’article 5.4.
							</p>

							<h3 class="font-weight-bold mb-8 mt-8">
								4. FONCTIONNALITES DU SERVICE
							</h3>
							<h4 class="font-weight-bold">
								4.1 Validation des demandes de paiement de gardes et
								d'astreintes déclarées par le responsable des plannings de garde
							</h4>
							<p class="mb-2">
								L’Utilisateur peut valider ou invalider les demandes de paiement
								de gardes et d’astreintes déclarées par le responsable des
								plannings de garde via la page « Demande de paiement (DPA) ».
							</p>

							<p class="mb-2">
								La validation est activée par le choix des gardes à valider et
								en cliquant sur le bouton « VALIDER DPA » générant une fenêtre
								de confirmation de la demande de validation. La confirmation de
								la validation génère d’une part un document au format « pdf »
								que l’Utilisateur peut conserver et enregistrer sur son poste de
								travail, et d’autre part l’envoi d’un mail qui l’informe que sa
								demande est prise en compte, et que s’il n’est pas à l’origine
								de cette demande, charge à lui de le signaler à sa Caisse
								d’Assurance Maladie de rattachement. La validation des demandes
								enclenche le paiement des gardes et astreintes par la Caisse
								d’Assurance Maladie de rattachement.
							</p>
							<p class="mb-2">
								Dans le cas où les informations relatives à une garde ou
								astreinte ne sont pas exactes, l’Utilisateur doit l’invalider
								via la page « Demande de paiement (DPA) ».
							</p>
							<p class="mb-2">
								L’invalidation est activée par le choix des gardes à invalider
								et en cliquant sur le bouton « INVALIDER GARDE » générant une
								fenêtre de confirmation de la demande d’invalidation. En cas de
								demande d’invalidation d’une garde ou astreinte, la Caisse
								d’Assurance Maladie de rattachement ne procèdera pas au paiement
								de ladite garde ou astreinte invalidée.
							</p>

							<h4 class="font-weight-bold mt-2">
								4.2 Consultation de la liste des gardes et astreintes effectuées
								par les professionnels de santé concernés
							</h4>
							<p class="mb-2">
								L’Utilisateur peut consulter l’ensemble des gardes et astreintes
								réalisées ainsi que le statut de chacune d’entre elles via
								notamment une recherche avancée.
							</p>

							<h4 class="font-weight-bold mt-2">
								4.3 Consultation d’un récapitulatif de la demande de paiements
								comportant la date de validation
							</h4>
							<p class="mb-2">
								L'Utilisateur a la possibilité de télécharger ce récapitulatif
								sous la forme d'un document « pdf » qui mentionne alors la date
								et l'heure d'édition du récapitulatif.
							</p>

							<h3 class="font-weight-bold mb-8 mt-8">
								5. PROTECTION DES DONNEES PERSONNELLES
							</h3>
							<h4 class="font-weight-bold">
								5.1 Préambule
							</h4>
							<p class="mb-2">
								L’Assurance Maladie traite l’ensemble de données personnelles
								qui lui sont confiées dans le cadre de ses missions et dans le
								respect des exigences règlementaires relatives à la protection
								des données personnelles et de la vie privée des personnes. La
								Politique générale de protection des données personnelles de
								l'Assurance Maladie est disponible sur ameli.
							</p>
							<p class="mb-2">
								Ce traitement a pour finalité principale de permettre aux
								professionnels de santé ou leurs mandataires d'effectuer
								certaines démarches et d'accéder aux informations les concernant
								et qui sont détenues par les organismes d'Assurance Maladie dans
								le cadre de leurs missions.
							</p>

							<h4 class="font-weight-bold mt-2">
								5.2 Responsable de traitement - Sous-traitant
							</h4>
							<p class="mb-2">
								La Cnam est le responsable du traitement de données au sens du
								règlement général sur la protection des données (RGPD) et de la
								loi n°78-17 du 6 janvier 1978 relative à l’informatique, aux
								fichiers et aux libertés modifiée.
							</p>
							<p class="mb-2">
								A ce titre, elle s’engage à prendre toutes précautions utiles au
								regard de la nature des données et des risques présentés par le
								traitement pour préserver la sécurité des données et, notamment,
								empêcher qu’elles soient déformées, endommagées ou que des tiers
								non autorisés y aient accès.
							</p>
							<p class="mb-2">
								L'Assurance Maladie ne pourra être tenue pour responsable des
								dommages que causerait un utilisateur de PEGASE ou la personne
								qui s'est vu délivrer des droits d'accès afin d'agir pour son
								compte, en utilisant des informations issues de cette
								application à d'autres fins que celles auxquelles elles sont
								destinées.
							</p>

							<h4 class="font-weight-bold mt-2">
								5.3 Données collectées
							</h4>
							<p class="mb-2">
								Les informations traitées dans le cadre du dispositif de
								paiement des gardes et astreintes sont :
							</p>
							<ul class="mb-2">
								<li>
									Des données transmises par les LGG permettant d’identifier le
									Professionnel de Santé ou de son mandataire (RPPS, numéro
									Assurance Maladie, numéro SIRET, numéro FINESS), et des
									données relatives aux astreintes réalisées (créneaux, secteurs
									de garde, des éléments de tarification, date de l'astreinte,
									date de validation).
								</li>
								<li>
									Des données issues des référentiels de l’Assurance Maladie
									complétant celles du professionnel de santé (état civil, nom,
									prénom, raison sociale).
								</li>
								<li>
									Des données obligatoires devant être saisies par le PS ou
									mandataire (l'adresse de courrier électronique).
								</li>
							</ul>

							<h4 class="font-weight-bold mt-2">
								5.4 Durée de conservation des données
							</h4>
							<p class="mb-2">
								Les informations relatives aux paiements sont conservées au
								maximum 5 ans à compter de la date de réalisation de la garde.
							</p>

							<p class="mb-2">
								Les informations de connexion sont supprimées du site au plus
								tard au bout d’un an.
							</p>

							<h4 class="font-weight-bold mt-2">
								5.5 Sécurité des données
							</h4>
							<p class="mb-2">
								Avant toute utilisation du compte, il appartient au
								professionnel de santé ainsi qu’au mandataire de s'assurer,
								d'une part, que le navigateur ou le réseau à partir duquel ils
								accèderont au site (réseau domestique ou réseau de l'opérateur
								de téléphonie mobile) et, d'autre part, que l'environnement
								d'exploitation des appareils sur lesquels l’application est
								installée, permettent l'accès dans une configuration sécurisée.
							</p>
							<p class="mb-2">
								Il leur appartient également de vérifier que la configuration
								informatique utilisée et l'environnement d'exploitation du ou
								des appareils utilisés sont sécurisés et ne contiennent
								notamment aucun virus et qu'ils sont en bon état de
								fonctionnement.
							</p>
							<p class="mb-2">
								Seuls les agents individuellement habilités par le directeur de
								leur organisme local d’assurance maladie peuvent accéder aux
								données strictement nécessaires à l’exercice de leurs missions,
								dans la limite du besoin d’en connaître et le respect du secret
								professionnel.
							</p>

							<h4 class="font-weight-bold mt-2">
								5.6 Droit d’accès, de rectification et d’opposition
							</h4>
							<p class="mb-2">
								Conformément à la règlementation relative à la protection des
								données en vigueur, le professionnel de santé ainsi que le
								mandataire disposent d’un droit d’accès et de rectification. Le
								droit d'opposition ne s'applique pas à ce traitement qui est
								nécessaire à une mission d'intérêt public. Ces droits s'exercent
								auprès du Directeur de la caisse d'Assurance Maladie de
								rattachement en contactant le délégué à la protection des
								données (DPO).
							</p>
							<p class="mb-2">
								En cas de difficultés dans l’application des droits énoncés
								ci-dessus, toute personne peut également introduire une
								réclamation auprès de l’autorité indépendante en charge du
								respect de la protection des données personnelles :
							</p>
							<p class="mb-2">
								Commission Nationale Informatique et Libertés - CNIL – 3 Place
								de Fontenoy TSA – 80715 – 75334 PARIS CEDEX 07.
							</p>

							<h4 class="font-weight-bold mt-2">
								5.7 Gestion des traceurs (cookies)
							</h4>
							<p class="mb-2">
								Un cookie est un petit fichier texte déposé sur votre terminal
								(ordinateur, tablette ou mobile) lors de la visite de notre
								site/plateforme/application. Il contient plusieurs données dont
								le nom du serveur qui l'a déposé, un identifiant sous forme de
								numéro unique, éventuellement une date d'expiration.
							</p>
							<p class="mb-2">
								Les cookies ont différentes fonctions. Ils peuvent permettre à
								celui qui l’a déposé de reconnaître un internaute, d’une visite
								à une autre, grâce à un identifiant unique.
							</p>
							<p class="mb-2">
								Lorsque l’Utilisateur accède au portail PEGASE via le site
								internet dédié, aucun cookie ou traceur n'est lu ou déposé.
								Lorsque l’Utilisateur accède au télé service via le portail
								Amelipro, des informations sur la navigation sont susceptibles
								d'être enregistrées ou lues sur le terminal des utilisateurs du
								site. Dans le cadre d’un accès à PEGASE via amelipro,
								l’Utilisateur doit se référer aux Conditions Générales
								d’Utilisation du service Amelipro.
							</p>

							<h3 class="font-weight-bold mb-8 mt-8">
								6. RESPONSABILITES
							</h3>
							<h4 class="font-weight-bold mt-2">
								6.1 Avertissement sur les contenus du service
							</h4>
							<p class="mb-2">
								L’Utilisateur est informé que les informations qui sont mises à
								sa disposition peuvent n’être ni complètes ni exhaustives et que
								ces informations ne traitent pas de l'intégralité des
								différentes gardes et astreintes réalisées (par exemple, celles
								qui ne sont pas encore transmises à l'Assurance Maladie).
							</p>
							<h4 class="font-weight-bold mt-2">
								6.2 Responsabilité de l’Utilisateur
							</h4>
							<p class="mb-2">
								L’Utilisateur est seul responsable des données qu'il a saisies
								pour son compte ou pour le compte du professionnel de santé pour
								lequel il a été mandaté. L’Utilisateur s'engage à respecter
								l'ensemble des conditions décrites dans les présentes Conditions
								Générales d’Utilisation.
							</p>
							<p class="mb-2">
								Les données traitées dans le cadre du service sont des données à
								caractère personnel, couvertes à ce titre par les dispositions
								de la loi Informatique et libertés et dont la violation est
								réprimée par l'article 226-13 du code pénal.
							</p>
							<p class="mb-2">
								L’Utilisateur est seul responsable de l'utilisation du service
								et des contenus renseignés et exportés par ses soins
								conformément à son usage, dans le respect des lois et règlements
								en vigueur et des présentes Conditions Générales d’Utilisation.
							</p>
							<p class="mb-2">
								L’Utilisateur est responsable de la conservation de ses
								identifiant et mot de passe permanents. Il s'interdit donc de
								les divulguer à quiconque. En cas de perte ou de vol de ses
								identifiants d'accès, l’Utilisateur peut changer son mot de
								passe (voir point 3.2.3).
							</p>

							<h4 class="font-weight-bold mt-2">
								6.3 Responsabilité de l’Assurance maladie
							</h4>
							<p class="mb-2">
								En sa qualité de responsable de traitement, l’Assurance Maladie
								a pris toutes les mesures utiles pour assurer la sécurité des
								données contenues dans le service.
							</p>
							<p class="mb-2">
								L’Assurance Maladie dégage toute responsabilité en cas :
							</p>
							<ul class="mb-2">
								<li>
									de survenance d'un événement de force majeure ayant un impact
									sur le service,
								</li>
								<li>de problèmes liés au réseau internet,</li>
								<li>
									de pannes ou dommages résultant des équipements de
									l’Utilisateur ou encore de la contamination du système
									informatique de l’Utilisateur par des virus, attaques et
									malveillances de tiers,
								</li>
								<li>
									d'utilisation de la plateforme par l’Utilisateur non conforme
									aux présentes Conditions Générales d’Utilisation.
								</li>
							</ul>
							<p class="mb-2">
								L’Assurance maladie ne saurait être tenue responsable des
								conséquences liées à une absence de disponibilité du service
								pour l’un des motifs mentionnés dans la partie « Disponibilité
								du service ».
							</p>

							<h3 class="font-weight-bold mb-8 mt-8">
								7. PROPRIETE INTELLECTUELLE
							</h3>
							<p class="mb-2">
								Pour tous les contenus, textes et logos présentés sur le présent
								service tous droits d'auteur des œuvres sont réservés.
							</p>
							<p class="mb-2">
								Sauf autorisation formelle écrite préalable, la reproduction
								ainsi que toute utilisation des œuvres, autres que la
								consultation individuelle et privée, sont interdites.
							</p>
							<p class="mb-2">
								Toute demande d'autorisation pour quelque utilisation que ce
								soit doit être adressée à :
							</p>
							<p class="mb-2">
								ASSURANCE MALADIE<br>
								Direction de la communication<br>
								26-50, avenue du Professeur André Lemierre<br>
								75986 Paris cedex 20
							</p>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-sheet>
			<v-spacer class="my-4" />
			<v-row
				align="center"
				justify="space-between"
			>
				<v-col
					cols="12"
					md="10"
				>
					<h2
						v-if="isLoggedIn && !cguAccepted"
						class="text-h4"
					>
						L'utilisation du service PEGASE requiert votre acceptation des CGU
					</h2>
				</v-col>
				<v-col
					cols="12"
					md="2"
				>
					<v-col
						cols="12"
						md="12"
						class="text-center text-md-right"
					>
						<AmeliproBtn
							v-if="isLoggedIn && !cguAccepted"
							class="v-btn-custom"
							@click="validerCgu"
						>
							Accepter les CGU
						</AmeliproBtn>
					</v-col>
				</v-col>
			</v-row>
		</AmeliproCard>
	</PageContainer>
</template>

<!-- eslint-enable max-len -->
<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import { Meta, MetaInfo } from '@/decorators';
	import { updateCguAccepted } from '@/services/api/api';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);
	import { store } from '@/store';

	@Component({})
	export default class Cgu extends MixinsDeclaration {
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Cgu' as string
			};
		}

		cguAccepted = false;
		mounted() {
			this.cguAccepted = this.utilisateurExterneInfo?.cguAccepted;
		}

		get cardTitle(): string {
			return this.isLoggedIn && !this.utilisateurExterneInfo?.cguAccepted
				? 'Merci de prendre connaissance des CGU du service'
				: 'Conditions Générales d\'Utilisation « PEGASE » ';
		}

		get isLoggedIn(): boolean {
			return this.$store.getters['authentication/isLoggedIn'];
		}

		async validerCgu(): Promise<void> {
			try {
				const success = await updateCguAccepted();
				if (success) {
					this.cguAccepted = true;
					await store.dispatch('authentication/storeUserInformation');
					this.$router.push('/');
					store.dispatch('notification/add', {
						type: 'success',
						message: 'Vous avez accepté les CGU.'
					});
				}
			} catch (error) {
				store.dispatch('notification/add', {
					type: 'error',
					message: 'Une erreur est survenue lors de l\'acceptation des CGU.'
				});
			}
		}
	}
</script>
<style scoped>
a {
  font-size: inherit;
}
</style>
